import { FETCH_REPEAT_PAYMENT_OFFER } from 'constants/payment';
import type { Offer } from 'models/offer';

type RepeatPaymentOfferAction = {
  type: typeof FETCH_REPEAT_PAYMENT_OFFER;
  payload: Offer;
};

const repeatPaymentOffer = (
  state: Offer | Record<string, never> = {},
  action: RepeatPaymentOfferAction,
) => {
  switch (action.type) {
    case FETCH_REPEAT_PAYMENT_OFFER:
      return action.payload;
    default:
      return state;
  }
};

export { repeatPaymentOffer };
